export type SidebarToolId =
  | 'text' | 'upload' | 'clipart' | 'artwork' | 'shapes' | 'background'
  | 'effects' | 'barcode' | 'template' | 'mydesigns' | 'layers'
  | 'qrcode';

export const ALL_SIDEBAR_TOOLS: SidebarToolId[] = [
  'text', 'upload', 'clipart', 'artwork', 'shapes', 'background',
  'effects', 'barcode', 'template', 'mydesigns', 'layers',
  'qrcode',
];

// Every sidebar tool has exactly one corresponding `Feature.featureUniqueLabel`
// row (admin > Features) — its `visibleAdmin` gates the tool on top of the
// per-Layout `tools` allow-list, and its drag-and-drop `position` in that grid
// is what `LeftSidebar.tsx` sorts the sidebar by (via `useFeatureFlags`).
// The Info panel is gated separately by `layoutConfig.infoPanel.enabled` and
// is NOT part of this tools allow-list.
export const SIDEBAR_TOOL_FEATURE_KEYS: Record<SidebarToolId, string> = {
  text:      'text_tool',
  upload:    'image_upload',
  clipart:   'clipart_browse',
  artwork:   'artwork_browse',
  shapes:    'shapes_browse',
  background:'bg_color',
  effects:   'image_effects',
  barcode:   'vdp_namenumber',
  template:  'template_load',
  mydesigns: 'my_designs',
  layers:    'layers_panel',
  qrcode:    'qr_code',
};

export interface LayoutFeatureConfig {
  tools: SidebarToolId[];
  header: { mode: 'tabs' };
  sideSwitcher: { style: 'tabs-top' };
  infoPanel?: { enabled: boolean; title?: string; lines?: string[] };
  // Gates the header tabs entirely.
  previewTabEnabled?: boolean;
  preview3dTabEnabled?: boolean;
}

export const DEFAULT_LAYOUT_FEATURE_CONFIG: LayoutFeatureConfig = {
  tools: ALL_SIDEBAR_TOOLS,
  header: { mode: 'tabs' },
  sideSwitcher: { style: 'tabs-top' },
  infoPanel: { enabled: false },
  previewTabEnabled: true,
  preview3dTabEnabled: true,
};

export interface ResolvedLayout {
  id: string | null;
  layoutName: string;
  featureConfig: LayoutFeatureConfig;
}

